
var currentLabel = '';

export const PopUp = {
    
    inject(selector, areaID = 'speech') {
        if (!this.areas) {
            this.areas = {}
        }
        this.areas[areaID] = document.createElement('div');
        this.areas[areaID].setAttribute("id", areaID);
        this.areas[areaID].setAttribute("class", "popup-area disabled");


        var targetDomElement = document.querySelector(selector);

        if (targetDomElement)
            targetDomElement.appendChild(this.areas[areaID])
        else {
            document.body.appendChild(this.areas[areaID])
        }
    },
    setLabel(label) {
        console.log(label)
        currentLabel = label;
        
    },
    showMessage(message, areaID = 'speech') {
        if (!this.areas) {
            console.warn("You forgot to call PopUp.injection(selector, areaID)")
            return
        }
        //console.log(this.areas[areaID])
        if (this.areas[areaID]) {
            this.areas[areaID].classList.remove('disabled');
            if (currentLabel && currentLabel != '') {
                message = `<span class="message-label">${currentLabel}</span>` + message;
            }
            this.areas[areaID].innerHTML = message;
        }
    },
    hide(areaID = 'speech') {
        if (this.areas[areaID]) {
            this.areas[areaID].classList.add("disabled");
        }
    }
}